<div class="loader-wrapper" id="loader_wrapper">
   <!-- <img  src="./assets/images/loader.gif" alt="loader" /> -->
   <div class="loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
   </div>
</div>
<!-- <div class="navbar navbar-expand-lg navbar-absolute fixed-top custom-navbar post-login-header bg-primary"
   data-aos="fade-down" data-aos-anchor-placement="top-bottom" data-aos-duration="700" data-aos-offset="100"
   data-aos-easing="ease-in-sine">
   <span class="float-right" (click)="toogleSideBar()"><i class="icon icon-cross"></i></span>
   <div class="container-fluid p-0">
      <div class="navbar-wrapper">
         <div class="toggle-sidebar float-left ml-4 pt-2" (click)="toogleSideBar()">
            <span class="navbar-toggler-icon icon-bar bg-white"></span>
            <span class="navbar-toggler-icon icon-bar bg-white"></span>
            <span class="navbar-toggler-icon icon-bar bg-white"></span>
         </div>
         <a class="navbar-brand" [routerLink]="'/home'">
            <img src="./assets/images/logo.jpg" alt="logo" style="width:40px" />
         </a>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index"
         aria-expanded="false" aria-label="Toggle navigation">

         <span class="sr-only">Toggle navigation</span>
         <span class="navbar-toggler-icon icon-bar"></span>
         <span class="navbar-toggler-icon icon-bar"></span>
         <span class="navbar-toggler-icon icon-bar"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end custom-search">
         <div class="navbar-form">
            <div class="input-group no-border">

               <select class="form-control-sm mr-2" #langSelect (change)="translate.use(langSelect.value)">
                  <option value=""> {{ 'ChooseLangauge' | translate }}</option>
                  <option *ngFor="let lang of translate.getLangs()" [value]="lang"
                     [selected]="lang === translate.currentLang">
                     {{lang}}</option>
               </select>
            </div>
         </div>
         <ul class="navbar-nav">
            <li class="nav-item mr-2">
               <button class="btn-sm btn-primary" (click)="open(content)">{{'SQM' | translate}}</button>
            </li>
            <li class="nav-item mr-2">
               <button type="button" class="btn-sm btn-primary" (click)="appAdmin()">{{'Monitor' | translate}}</button>
            </li>


            <li class="nav-item dropdown">
               <a class="nav-link dropdown-toggle p-0" data-toggle="dropdown" id=Profile aria-expanded="false"
                  [routerLink]="[]">
                  <i class="fa fa-user-circle"></i>
                  <img src="./assets/images/user.svg" alt="logo" />
               </a>

               <ul class="dropdown-menu" aria-labelledby="Profile">
                  <li class="nav-item active">
                     <a [routerLink]="'/myprofile'">

                        {{ 'PostLogInHeader.MyProfile.Name' | translate }}</a>
                  </li>
                  <li class="nav-item active">
                     <a [routerLink]="'/changepasswordlink'">

                        {{ 'PostLogInHeader.ChangePasswordLink.Name' | translate }}</a>
                  </li>
                  <li class="nav-item active">
                     <a (click)="logout()" [routerLink]="'/logout'">
                        {{ 'PostLogInHeader.Logout.Name' | translate }}</a>
                  </li>
               </ul>
            </li>
         </ul>


      </div>
   </div>
</div> -->

<nav class="custon-navbar navbar navbar-expand-lg">
   <div class="container-fluid">
     <a class="navbar-brand" href="#">
       <img src="./assets/images/owl-esg-logo.png" />
     </a>
     <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup"
       aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
       <span class="navbar-toggler-icon"></span>
     </button>
     <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
       <ul class="navbar-nav ms-auto">
         <!-- <li class="nav-item">
           <form class="header-search">
             <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
           </form>
         </li> -->
         <li class="nav-item">
           <a href="#" class="nav-link icon-item me-2" placement="bottom" ngbTooltip="Dark mode"
             tooltipClass="custome-tooltip">
             <i class="fa-solid fa-sun font-18"></i>
           </a>
         </li>
         <li class="nav-item dropdown user-profile">
           <a class="nav-link dropdown-toggle p-0" id="navbarDarkDropdownMenuLink" role="button"
             data-bs-toggle="dropdown" aria-expanded="false">
             <i class="fa-regular fa-user text-primary user-icon"></i>
           </a>
           <ul class="dropdown-menu" aria-labelledby="navbarDarkDropdownMenuLink">
             <li class="dropdown-item user-details">
               <p class="text-center text-medium text-white">John Doe</p>
               <p class="text-center text-white font-12">Admin</p>
             </li>
             <li class="dropdown-item float-start w-100"><a class="float-start w-100" href="#"><i
                   class="fa-solid fa-gear"></i> Profile Setting</a></li>
             <li class="dropdown-item float-start w-100"><a class="float-start w-100" href="#"><i
                   class="fa-solid fa-right-from-bracket"></i> Logout</a></li>
           </ul>
         </li>
       </ul>
     </div>
   </div>
 </nav>

<!-- <div class="mobile-bottom bg-primary">
   <ul>
      <li>
         <a [routerLink]="'/myprofile'">
            <i class="icon icon-user"></i>
            <span>Profile</span>
         </a>
      </li>
      <li>
         <a [routerLink]="'/home'">
            <i class="icon icon-home bg-dark"></i>
            <span>Home</span>
         </a>
      </li>
      <li>
         <a (click)="logout()" [routerLink]="'/logout'">
            <i class="icon icon-login"></i>
            <span>Logout</span>
         </a>
      </li>
   </ul>
</div>

<ng-template #content let-modal>
   <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ 'SuportPageHeaderName' | translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
         <span aria-hidden="true">&times;</span>
      </button>
   </div>
   <div class="modal-body sqm-modal">
      <form name="SuportPage" id="SupportTeamFormId" [formGroup]="form" method="post" novalidate>
         <div class="custom-form-group">
            <div class="form-group">
               <label for="SubjectId">{{ 'SuportPageSubjectName' | translate }} </label>
               <input type="textArea" name="subject" id="SubjectId" class="form-control validate"
                  formControlName="subject" required>
               <div class="invalid-feedback"> </div>
            </div>
            <div class="form-group">
               <label for="MessageId"> {{ 'SuportPageMessageName' | translate }}</label>
               <textarea name="message" id="MessageId" class="form-control validate" formControlName="message" row="3"
                  required></textarea>
               <div class="invalid-feedback"> </div>
            </div>
            <input type="hidden" name="ScreenPat" formControlName="screenPath" id="ScreenPathId"
               class="form-control validate" required>
            <small class="text-success">{{ 'SuportPageMailMessage' | translate }}</small>
         </div>

         <div class="modal-footer">
            <button type="button" class="btn btn-primary" id="btnSendMail" (click)="sendEmail()">{{
               'SuportPageButtonName' | translate}}</button>
         </div>

      </form>

   </div>

</ng-template> -->